import Head from "next/head";

import AboutUs from "../components/AboutUs";
import { FlashPCBPage } from "../models/page";

const AboutFlashPCB: FlashPCBPage = () => {
  return (
    <>
      <Head>
        <title>About FlashPCB</title>
        <meta name="description" content="Meet the team" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <AboutUs />
    </>
  );
};

export default AboutFlashPCB;
